<template>
    <div class="skillSetting-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/productList' }">产品列表</el-breadcrumb-item>
            <el-breadcrumb-item>技能商店</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="top">
            <div class="item">
                <a href="javascript:;" class="all-skill-a" v-bind:style="{color: all}"
                   @click="getSkillList('all_skill')">所有技能</a>
            </div>
            <div class="item">
                <a href="javascript:;" v-bind:style="{color: priv}" @click="getSkillList('private_skill')">我的技能</a>
            </div>
            <div class="item">
                <a href="javascript:;" v-bind:style="{color: mine}" @click="getSkillList('my_skill')">已添加技能</a>
            </div>
            <div class="item" style="position: relative;">
                <el-input class="search-input" placeholder="搜索您想要的技能" v-model="searchSkill"
                          @keyup.enter.native="searchAllSkill"></el-input>
                <i class="el-icon-search" @click="searchAllSkill"></i>
            </div>
        </div>
        <!--  -->
        <div class="bottom">
            <div v-if="(this.allList.length == 0 && (this.list_type == 'all_skill' || this.list_type == 'private_skill' || this.list_type == 'my_skill'))"
                 class="nS">暂无技能，快去添加一些吧
            </div>
            <div v-if="(this.allList.length == 0 && (this.list_type == 'search_all_skill' || this.list_type == 'search_my_skill' || this.list_type == 'search_private_skill'))"
                 class="nS">没搜到您想要的技能，换一个试试吧
            </div>
            <div class="item">
                <div class="item-content" v-for="(item, index) in allList" :key="item.id" @click="skillInfo(item)">
                    <div class="item-content-top">
                        <div class="top-part">
                            <img :src="item.skill_icon_url" alt="">
                        </div>
                        <div class="top-part2">
                            <div class="top-part-param">{{item.skill_name}}</div>
                            <div class="top-part-param">{{item.nlu_cate_name}}</div>
                            <div class="top-part-param">添加数: <span>{{item.invoke_num | conversion}}</span></div>
                        </div>
                        <!--<el-button v-show="item.invoke_status == '0'" type="primary" size="mini" round class="use_btn">引用</el-button>-->
                        <el-button v-show="item.invoke_status == '0'" type="primary" size="mini" round class="use_btn"
                                   @click.prevent.stop="invokeSkill(item)">添加
                        </el-button>
                        <el-button v-show="item.invoke_status == '1'" type="primary" size="mini" round class="use_btn"
                                   @click.prevent.stop="invokeSkillDelete(item, index)">取消添加
                        </el-button>
                    </div>
                    <!--  -->
                    <div class="item-content-bottom" style="-webkit-box-orient: vertical">
                        {{item.skill_intro}}
                    </div>
                </div>
            </div>
        </div>
        <div class="block">
            <el-pagination
                    layout="prev, pager, next"
                    :current-page="page.current_page"
                    prev-text="上一页"
                    next-text="下一页"
                    :page-size="page.per_page"
                    :total="page.total"
                    @current-change="changePage">

            </el-pagination>
        </div>
    </div>
</template>
<script>
    import qs from 'qs'
    import CommonMethods from '@/mixins/commonMethods'
    import {
        skillLApi,
        myskillLApi,
        myaddskillLApi,
        invokeSkillApi,
        invokeSkillDeleteApi,
        searchSkillLApi
    } from '@/api/hardIndex.js'

    export default {
        mixins: [
            CommonMethods
        ],
        data() {
            return {
                searchSkill: "",
                all: "rgb(64, 132, 231)",
                mine: "rgb(138, 138, 138)",
                priv: "rgb(138, 138, 138)",
//        tecChoice: true,
                allList: [
//          {
//            avatar: "http://39.106.53.230/map/avatar.jpg",
//            task: "查快递",
//            type: "工具",
//            useNum: 2344556,
//            des: "用户可以通过语音交互方便查询快递信息查询快递信息查询快递信息"
//          },
                ],
                useTxt: "添加",
                c_page: 1,
                listType: 0,
                page: {},
                list_type: 'all_skill'
            };
        },
        created() {
            let skillStatus = this.$store.state.skillSetting;
            let page = this.$store.state.page;
            this.c_page = page
            if (skillStatus == 'all') {
                this.getSkillList('all_skill', page);
            } else if (skillStatus == 'priv') {
                this.getSkillList('private_skill', page);
            } else if (skillStatus == 'mine') {
                this.getSkillList('my_skill', page);
            } else {
                this.getSkillList('all_skill', page);
            }
        },
        methods: {
            changePage: function (page) {
                this.c_page = page
                this.getSkillList(this.list_type, this.c_page)
            },
            async getSkillList(list_type, c_page = 1) {
                this.list_type = list_type
                if (list_type == 'all_skill') {
                    this.all = "rgb(64, 132, 231)"
                    this.mine = "rgb(138, 138, 138)"
                    this.priv = "rgb(138, 138, 138)"

                } else if (list_type == 'my_skill') {
                    this.all = "rgb(138, 138, 138)"
                    this.mine = "rgb(64, 132, 231)"
                    this.priv = "rgb(138, 138, 138)"

                } else if (list_type == 'private_skill') {
                    this.all = "rgb(138, 138, 138)"
                    this.mine = "rgb(138, 138, 138)"
                    this.priv = "rgb(64, 132, 231)"

                }
                this.listType = 0
                let res = await skillLApi(qs.stringify({
                    'client_id': this.$route.query.client_id,
                    'page': c_page,
                    list_type: list_type,
                    skill_name: this.searchSkill
                }))
                if (res.data.code == 200) {
                    this.allList = res.data.data
                    this.page = res.data.params.page
                    this.searchSkill = ''
                } else {
                    this.$message.error('获取列表失败')
                    this.searchSkill = ''
                }
            },
            searchAllSkill() {
                if (this.list_type == 'all_skill') {
                    this.getSkillList('search_all_skill')

                } else if (this.list_type == 'my_skill') {
                    this.getSkillList('search_my_skill')

                } else if (this.list_type == 'private_skill') {
                    this.getSkillList('search_private_skill')

                }
            },
            async invokeSkill(item) {
                let res = await invokeSkillApi(qs.stringify({
                    'client_id': this.$route.query.client_id,
                    'skill_id': item.skill_id
                }))
                if (res.data.code == 200) {
                    this.$message.success('添加成功')
//          item.invoke_num = item.invoke_num + 1
                    item.invoke_status = 1
                } else {
                    this.$message.error('添加失败')
                }
            },
            async invokeSkillDelete(item, index) {
//        console.log(index);
                let res = await invokeSkillDeleteApi(qs.stringify({
                    'client_id': this.$route.query.client_id,
                    'skill_id': item.skill_id
                }))
                if (res.data.code == 200) {
                    this.$message.success('取消添加成功')
                    this.changePage(this.c_page)
//            this.allList.splice(index,1)
//            item.invoke_num = item.invoke_num - 1
                    item.invoke_status = 0
                    if (this.allList.length == 0) {
                        this.$message.warning('暂无技能，快去添加一些吧')
                    }

                } else {
                    this.$message.error('取消添加失败')
                }
            },
            skillInfo(item) {
                if (this.list_type == 'all_skill') {//记录用户点击前的位置
                    this.$store.dispatch('changeSkillSetting', {e: 'all', page: this.c_page});
                } else if (this.list_type == 'private_skill') {
                    this.$store.dispatch('changeSkillSetting', {e: 'priv', page: this.c_page});
                } else if (this.list_type == 'my_skill') {
                    this.$store.dispatch('changeSkillSetting', {e: 'mine', page: this.c_page});
                }
                let clientId = this.$route.query.client_id;
                this.$router.push('/skillInfo?skill_id=' + item.skill_id + '&client_id=' + clientId)
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .skillSetting-box {
        width: 100%;
        height: 100%;
        background-color: rgb(247, 248, 247);

        img {
            width: 100%;
            height: 100%;
        }

        @mixin block {
            display: inline-block;
            vertical-align: middle;
        }

        .top {
            width: 100%;
            height: 64px;
            line-height: 64px;
            background-color: #fff;
            .item {
                width: 10%;
                @include block;
                text-align: center;
                &:nth-child(1), &:nth-child(2) {
                    height: 15px;
                    line-height: 15px;
                    border-right: 1px solid rgb(187, 187, 187);
                }
                &:nth-child(3) {
                    height: 15px;
                    line-height: 15px;
                }
                &:nth-child(4) {
                    width: 18%;
                    margin-left: 50%;
                    i {
                        width: 10px;
                        position: absolute;
                        right: 8%;
                        top: 36%;
                        font-size: 16px;
                        color: #ccc;
                    }
                }
                a {
                    text-decoration: none;
                    color: rgb(138, 138, 138);
                    font-size: 15px;
                }
            }
        }
        .nS {
            width: 100%;
            height: 450px;
            text-align: center;
            background: #fff;
            padding: 30px 30px 30px 0;
            color: rgb(138, 138, 138);
            margin-top: 20px;
        }
        .bottom {
            width: 100%;
            min-height: 90%;
            .item {
                .item-content {
                    cursor: pointer;
                    width: 30%;
                    // min-width: 340px;
                    margin-left: 20px;
                    height: 180px;
                    @include block;
                    background-color: #fff;
                    position: relative;
                    padding: 15px;
                    margin-top: 20px;
                    .item-content-top {
                        position: relative;
                        display: flex;
                        .top-part {
                            width: 70px;
                            height: 70px;
                            border-radius: 10px;
                            /*border: 1px solid #ccc;*/
                            overflow: hidden;
                        }
                        .top-part2 {
                            margin-left: 10px;
                            .top-part-param {
                                width: 142px;
                                line-height: 22px;
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                        }
                        .use_btn {
                            position: absolute;
                            right: 0;
                            top: 0;
                        }
                    }
                    .item-content-bottom {
                        margin-top: 20px;
                        display: -webkit-box;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2

                    }
                    &:nth-child(3n + 1) {
                        margin-left: 0;
                    }
                }
            }
        }

        .block {
            text-align: right;
            padding: 10px 10px 0 0;
            .el-pagination {
                button,
                li {
                    background-color: transparent;
                }
            }
        }
        .search-input {
            input {
                border-radius: 20px;
                height: 34px;
                line-height: 34px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/hardware/pro/SkillSetting.vue